import { spreadSearchQuery } from "helpers/utilities"
import { get } from "../api_helper2"

const BASE_API_URL = `${process.env.REACT_APP_MASTER_SETUP_ENDPOINT}/login_history`

const getAllLoginHistory = payload => {
    let q = spreadSearchQuery(payload)
    return get(`${BASE_API_URL}?${q}`)
}

const exportExcelLoginHistory = query => {
    let q = spreadSearchQuery(query)
    return get(`${BASE_API_URL}/export-excel?${q}`, {
        responseType: 'blob'
    })
}

export {
    getAllLoginHistory,
    exportExcelLoginHistory
}

